// extracted by mini-css-extract-plugin
export default {"main":"SubnivelAsignaturaSelector_main__+oO51","placeholder":"SubnivelAsignaturaSelector_placeholder__TS1LB"};